import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  profile: {
    get: () => client.get("/profile").then((r) => r.data),
    update: (data) => client.put("/profile", data).then((r) => r.data),
  },
  telegram: { setWebhook: () => client.post("/telegram/set-webhook").then((r) => r.data) },
  agent: {
    chat: (text) => client.post("/agent/chat", { text, source: "dashboard" }).then((r) => r.data),
    history: () => client.get("/agent/history").then((r) => r.data),
  },
  integrations: {
    list: () => client.get("/integrations").then((r) => r.data),
    connect: (name) => client.post(`/integrations/${name}/connect`).then((r) => r.data),
    disconnect: (name) => client.post(`/integrations/${name}/disconnect`).then((r) => r.data),
  },
  trust: {
    list: () => client.get("/trust").then((r) => r.data),
    update: (action, tier) => client.put(`/trust/${action}`, { tier }).then((r) => r.data),
  },
  memory: {
    list: () => client.get("/memory").then((r) => r.data),
    create: (data) => client.post("/memory", data).then((r) => r.data),
    remove: (id) => client.delete(`/memory/${id}`).then((r) => r.data),
  },
  tasks: {
    list: () => client.get("/scheduled-tasks").then((r) => r.data),
    toggle: (id) => client.put(`/scheduled-tasks/${id}/toggle`).then((r) => r.data),
    runNow: (id) => client.post(`/scheduled-tasks/${id}/run-now`).then((r) => r.data),
  },
  activity: { list: (limit = 100) => client.get(`/activity?limit=${limit}`).then((r) => r.data) },
  approvals: {
    list: (status) => client.get("/approvals" + (status ? `?status=${status}` : "")).then((r) => r.data),
    decide: (id, decision) => client.post(`/approvals/${id}/decide`, { decision }).then((r) => r.data),
  },
  upload: (file) => {
    const fd = new FormData(); fd.append("file", file);
    return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
  },
};
